import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query CustomerPreviewQuery {
      allStoryblokEntry(filter: { field_component: { in: [ "Customer" ] } }) {
        nodes {
          uuid
          name
          lang
          full_slug
          content
          published_at(formatString: "MMMM d, YYYY")
        }
      }
    }
  `);

  const customerPreviews = allStoryblokEntry.nodes.map((post) => {
    const content = JSON.parse(post.content);
    const { logo, previewImage } = content;
    return {
      ...post,
      content,
      lang: post.lang,
      logo,
      previewImage
    };
  });

  return customerPreviews;
};
